import React, { Component, Fragment } from "react";
//import Cookies from "js-cookie";
import Theme from "../../assets/Theme";
import style from "./../../config/style.json";
import config from "./../../config/config.json";
import clsx from "clsx";
import {
  Toolbar,
  AppBar,
  Typography,
  IconButton,
  Container,
  Icon,
  Avatar,
  Collapse,
  Link,
  Alert,
  Button,
  Grid,
  TextField,
  CircularProgress,
} from "@mui/material";
import SidebarNavigation from "./partials/SidebarNavigation";
import MenuDropdown from "./partials/MenuDropdown";
import { Navigate, useNavigate, useLocation, NavLink as RouterLink } from "react-router-dom";
import { buildDashboardPath } from "../../hooks/useDashboardPath";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../assets/images/logo-white.png";
import { Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { connect } from "react-redux";
import ProfileImageUploadModal from "./partials/ProfileImageUploadModal";
import { ENV } from "../../config/config.js"
import { getAdditionalUserData } from "../../hooks/useAdditionalUserData";
import { sanitizeAccountUid, safeParseJson, ensureArray } from "../../utils/inputSanitizers";

class MainAdmin extends Component {
  constructor(props) {
    super(props);
    this.user = window.localStorage.getItem("user");
    this.filteredHotelsCache = {
      list: null,
      searchText: null,
      result: [],
    };
    this.state = {
      open: true,
      mode: "ADMIN",
      userData: {},
      statusLogin: false,
      cards: config.cards,
      responseForgot: "",
      openAlert: true,
      showSidebar: null,
      title: "",
      showHotelSelection: false,
      showSwitchAccount: false,
      listHotels: null,
      searchText: "",
      hasSelectedHotel: window.localStorage.getItem("selectedHotel"),
      redirectToHome: false,
      userDataApi: null,
      showSwitchAdmin: false,
      showAdmin: false,
      showOverview: false,
      isAdmin: window.localStorage.getItem("isAdmin"),
      additionalUserData: {},
      sentListAccounts: false,
      sentUserUpdate: false,
      queryParams: {
        page_size: 1000,
      },
      showProfileModal: false,
    };
    this.environmentIdentifier = ENV;
  }

  getAccountsCount = () => {
    const additionalUserData = getAdditionalUserData();
    const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
    
    if (isSuperUser) {
      const allHotels = ensureArray(safeParseJson(localStorage.getItem("allHotels"), []));
      return allHotels.length;
    }
    return additionalUserData?.permissionsByAccount?.length || 0;
  };

  shouldShowSwitchAccount = () => {
    return this.getAccountsCount() > 1;
  };

  shouldShowOverview = () => {
    const additionalUserData = getAdditionalUserData();
    const isAccountManager = additionalUserData?.roles?.includes("ROLE_ACCOUNT_MANAGER");
    const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
    return isAccountManager && !isSuperUser;
  };

  validateToken = () => {
    try {
      const headersSetCookie = window.localStorage.getItem("headersSetCookie");
      if (!headersSetCookie) {
        this.logout();
        return;
      }

      const userDataJWT = jwtDecode(headersSetCookie);
      const now = Math.floor(Date.now() / 1000);

      if (userDataJWT.exp && now >= userDataJWT.exp) {
        this.logout();
      }
    } catch (error) {

      this.logout();
    }
  };

  componentDidMount() {
    this.handleHotelChanged = (e) => {
      if (e.detail?.title) {
        this.setState({
          title: e.detail.title,
          hasSelectedHotel: e.detail.title,
          showSwitchAccount: this.shouldShowSwitchAccount(),
          showOverview: false,
          showHotelSelection: false,
          isAdmin: false,
        });
      }
    };
    window.addEventListener("hotelChanged", this.handleHotelChanged);

    const pathname = (this.props.location?.pathname || '').replace(/\/$/, "");
    
    const additionalUserData = getAdditionalUserData();
    const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");

    if (!isSuperUser && (pathname === '/dashboard/select' || pathname.startsWith('/dashboard/'))) {
      this.handleRouteChange();
    } else if (isSuperUser && pathname.startsWith('/dashboard/admin')) {
      this.handleRouteChange();
    } else {
      const isAdmin = window.localStorage.getItem("isAdmin") === "true";
      const persistedTitle = window.localStorage.getItem("selectedHotel");
      if (!isAdmin && persistedTitle) {
        this.setState({
          title: persistedTitle,
          hasSelectedHotel: persistedTitle,
          showSwitchAccount: this.shouldShowSwitchAccount(),
          showOverview: false,
          showHotelSelection: false,
          isAdmin: false,
        });
      }
    }

    const headersSetCookie = window.localStorage.getItem("headersSetCookie");

    if (!headersSetCookie || !additionalUserData) {
      this.logout();
      return;
    }

    const userDataJWT = jwtDecode(headersSetCookie);
    const now = Math.floor(Date.now() / 1000);
    if (userDataJWT.exp && now >= userDataJWT.exp) {
      this.logout();
      return;
    }

    this.interval = setInterval(() => {
      this.validateToken();
    }, 60 * 1000);

    window.localStorage.setItem("userData", JSON.stringify(userDataJWT));
    if (!window.localStorage.getItem("firstLogin")) {
      window.localStorage.setItem(
        "firstLogin",
        JSON.stringify(userDataJWT.firstLogin)
      );
    }

    this.setState(
      {
        userDataApi: userDataJWT,
        additionalUserData,
      },
      () => {
        if (additionalUserData.roles?.includes("ROLE_SUPERUSER")) {
          const queryString = `?page_size=${this.state.queryParams.page_size}&include=subscription&originSystem=A2`;
          this.props.getAccountListFiltered(
            headersSetCookie,
            queryString,
            null,
            additionalUserData.uuid
          );
          this.setState({ sentListAccounts: true });
        } else {
          this.handleWebService(
            this.state.additionalUserData.permissionsByAccount
          );
        }
      }
    );

    const isAdmin = window.localStorage.getItem("isAdmin") === "true";

    if (pathname === "/dashboard/select") {
      const additionalUserData = getAdditionalUserData();
      const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
      
      let accountsList = [];
      if (isSuperUser) {
        accountsList = ensureArray(safeParseJson(localStorage.getItem("allHotels"), []));
      } else {
        accountsList = (additionalUserData?.permissionsByAccount || []).map((acc) => ({
          accountName: acc.accountName,
          accountUuid: acc.accountUuid,
          accountUid: acc.accountUid,
          accountCurrency: acc.accountCurrency || "",
          accountDateFormat: acc.accountDateFormat || "",
          accountTimeFormat: acc.accountTimeFormat || "",
          accountPropertyId: acc.accountPropertyId || "",
          accountSubscriptionName: acc.accountSubscriptionName || "",
          managePropertiesList: acc.managePropertiesList === true,
        }));
      }

      if (accountsList.length === 1) {
        const account = accountsList[0];
        window.localStorage.setItem("uuidSetCookie", account.accountUuid);
        window.localStorage.setItem("accountUid", account.accountUid);
        window.localStorage.setItem("selectedHotel", account.accountName);
        window.localStorage.setItem("currencyAccount", account.accountCurrency || "");
        window.localStorage.setItem("dateFormatAccount", account.accountDateFormat || "");
        window.localStorage.setItem("timeFormatAccount", account.accountTimeFormat || "");
        window.localStorage.setItem("propertyIdAccount", account.accountPropertyId || "");
        window.localStorage.setItem("accountSubscriptionName", account.accountSubscriptionName || "");
        window.localStorage.setItem("managePropertiesList", account.managePropertiesList === true ? "true" : "false");
        
        this.setState({
          showHotelSelection: false,
          showSwitchAccount: false,
          showSidebar: true,
          title: account.accountName,
          hasSelectedHotel: account.accountName,
          isAdmin: false,
        }, () => {
          this.props.navigate(`/dashboard/${account.accountUid}`, { replace: true });
          window.dispatchEvent(new CustomEvent("hotelChanged", { detail: { title: account.accountName } }));
        });
        return;
      }
      
      window.localStorage.removeItem("selectedHotel");
      window.localStorage.removeItem("uuidSetCookie");
      window.localStorage.removeItem("currencyAccount");
      window.localStorage.removeItem("dateFormatAccount");
      window.localStorage.removeItem("timeFormatAccount");
      window.localStorage.removeItem("propertyIdAccount");
      window.localStorage.removeItem("accountSubscriptionName");
      window.localStorage.removeItem("managePropertiesList");
      window.localStorage.removeItem("isAdmin");
      window.localStorage.removeItem("isOverview");

      this.setState({
        showHotelSelection: true,
        showSwitchAccount: false,
        title: "Admin Panel",
        showAdmin: isSuperUser,
        showOverview: this.shouldShowOverview(),
        listHotels: accountsList,
        isAdmin: false,
      }, () => {
        this.props.navigate("/dashboard/select", { replace: true });
      });
      return;
    }

  }

  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener("hotelChanged", this.handleHotelChanged);
  }

  handleRouteChange = () => {
    const pathname = (this.props.location?.pathname || '').replace(/\/$/, "");
    const isAdmin = window.localStorage.getItem("isAdmin") === "true";
    const isOverview = window.localStorage.getItem("isOverview") === "true";
    const selectedHotel = window.localStorage.getItem("selectedHotel");
    const extractUidFromPath = (path) => {
      if (!path.startsWith('/dashboard/')) {
        return null;
      }
      const parts = path.split('/').filter(Boolean);
      if (parts.length < 2 || parts[0] !== 'dashboard') {
        return null;
      }
      const uid = parts[1];
      if (!uid || uid === 'admin' || uid === 'overview') {
        return null;
      }
      return sanitizeAccountUid(uid);
    };
    const handleAccountSwitch = (uidFromPath, accountsList) => {
      if (!uidFromPath) {
        return false;
      }
      const matchingAccount = accountsList.find((acc) => acc.accountUid === uidFromPath);
      if (!matchingAccount) {
        this.props.navigate('/dashboard/select', { replace: true });
        return true;
      }

      window.localStorage.setItem("selectedHotel", matchingAccount.accountName);
      window.localStorage.setItem("uuidSetCookie", matchingAccount.accountUuid);
      window.localStorage.setItem("accountUid", matchingAccount.accountUid);
      window.localStorage.setItem("currencyAccount", matchingAccount.accountCurrency || "");
      window.localStorage.setItem("dateFormatAccount", matchingAccount.accountDateFormat || "");
      window.localStorage.setItem("timeFormatAccount", matchingAccount.accountTimeFormat || "");
      window.localStorage.setItem("propertyIdAccount", matchingAccount.accountPropertyId || "");
      window.localStorage.setItem(
        "managePropertiesList",
        matchingAccount.managePropertiesList === true ? "true" : "false"
      );
      window.localStorage.setItem("accountSubscriptionName", matchingAccount.accountSubscriptionName || "");
      window.localStorage.setItem("isAdmin", "false");
      window.localStorage.setItem("isOverview", "false");

      this.setState({
        showHotelSelection: false,
        showSwitchAccount: this.shouldShowSwitchAccount(),
        showOverview: false,
        showAdmin: false,
        showSidebar: true,
        title: matchingAccount.accountName,
        isAdmin: false,
        hasSelectedHotel: matchingAccount.accountName,
      }, () => {
        window.dispatchEvent(new CustomEvent("hotelChanged", { detail: { title: matchingAccount.accountName } }));
      });
      return true;
    };

    if (pathname === '/dashboard/select') {
      const additionalUserData = getAdditionalUserData();
      const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
      
      let listHotels = [];
      if (isSuperUser) {
        listHotels = ensureArray(safeParseJson(localStorage.getItem("allHotels"), []));
      } else {
        listHotels = (additionalUserData?.permissionsByAccount || []).map((acc) => ({
          accountName: acc.accountName,
          accountUuid: acc.accountUuid,
          accountUid: acc.accountUid,
          accountCurrency: acc.accountCurrency || "",
          accountDateFormat: acc.accountDateFormat || "",
          accountTimeFormat: acc.accountTimeFormat || "",
          accountPropertyId: acc.accountPropertyId || "",
          accountSubscriptionName: acc.accountSubscriptionName || "",
          managePropertiesList: acc.managePropertiesList === true,
        }));
      }

      window.localStorage.removeItem("isAdmin");
      window.localStorage.removeItem("isOverview");

      this.setState({
        showHotelSelection: true,
        showSwitchAccount: false,
        showAdmin: isSuperUser,
        showOverview: this.shouldShowOverview(),
        title: "Admin Panel",
        listHotels,
        hasSelectedHotel: null,
        isAdmin: false,
      });
    } else if (pathname.startsWith('/dashboard/admin')) {
      const additionalUserData = getAdditionalUserData();
      const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
      
      if (!isSuperUser) {
        const pathAfterAdmin = pathname.replace(/^\/dashboard\/admin/, "");
        const persistedAccountUid = localStorage.getItem("accountUid");
        if (isOverview) {
          this.props.navigate(`/dashboard/overview${pathAfterAdmin}`, { replace: true });
        } else if (persistedAccountUid) {
          this.props.navigate(`/dashboard/${persistedAccountUid}${pathAfterAdmin}`, { replace: true });
        } else {
          this.props.navigate('/dashboard/select', { replace: true });
        }
        return;
      }
      
      window.localStorage.removeItem("selectedHotel");
      window.localStorage.removeItem("accountUid");
      window.localStorage.setItem("isAdmin", "true");
      window.localStorage.setItem("isOverview", "false");
      window.localStorage.setItem("uuidSetCookie", additionalUserData.uuid);
      window.localStorage.setItem("currencyAccount", "");
      window.localStorage.setItem("dateFormatAccount", "");
      window.localStorage.setItem("timeFormatAccount", "");
      window.localStorage.setItem("propertyIdAccount", "");
      window.localStorage.setItem("managePropertiesList", "");
      window.localStorage.setItem("accountSubscriptionName", "");
      
      this.setState({
        showHotelSelection: false,
        showSwitchAccount: this.shouldShowSwitchAccount(),
        showOverview: false,
        showAdmin: false,
        showSidebar: true,
        title: "ADMIN",
        isAdmin: true,
        hasSelectedHotel: null,
      });
    } else if (pathname.startsWith('/dashboard/overview')) {
      const additionalUserData = getAdditionalUserData();
      const overviewUuid = additionalUserData?.uuid || this.state.userDataApi?.uuid;
      window.localStorage.removeItem("selectedHotel");
      window.localStorage.removeItem("accountUid");
      window.localStorage.setItem("isAdmin", "false");
      window.localStorage.setItem("isOverview", "true");
      if (overviewUuid) {
        window.localStorage.setItem("uuidSetCookie", overviewUuid);
      }
      window.localStorage.setItem("currencyAccount", "");
      window.localStorage.setItem("managePropertiesList", "");
      window.localStorage.setItem("accountSubscriptionName", "");

      this.setState({
        showHotelSelection: false,
        showSwitchAccount: this.shouldShowSwitchAccount(),
        showOverview: false,
        showAdmin: false,
        showSidebar: true,
        title: "Overview",
        isAdmin: false,
        hasSelectedHotel: null,
      });
    } else if (pathname.startsWith('/dashboard/')) {
      const uidFromPath = extractUidFromPath(pathname);
      const currentAccountUid = window.localStorage.getItem("accountUid");

      if (uidFromPath && uidFromPath !== currentAccountUid) {
        const additionalUserData = getAdditionalUserData();
        const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
        
        let accountsList = [];
        if (isSuperUser) {
          accountsList = ensureArray(safeParseJson(localStorage.getItem("allHotels"), []));
        } else {
          accountsList = (additionalUserData?.permissionsByAccount || []).map((acc) => ({
            accountName: acc.accountName,
            accountUuid: acc.accountUuid,
            accountUid: acc.accountUid,
            accountCurrency: acc.accountCurrency || "",
            accountDateFormat: acc.accountDateFormat || "",
            accountTimeFormat: acc.accountTimeFormat || "",
            accountPropertyId: acc.accountPropertyId || "",
            accountSubscriptionName: acc.accountSubscriptionName || "",
            managePropertiesList: acc.managePropertiesList === true,
          }));
        }
        
        if (handleAccountSwitch(uidFromPath, accountsList)) {
          return;
        }
      }
      
      const title = selectedHotel || "";
      this.setState({
        showHotelSelection: false,
        showSwitchAccount: this.shouldShowSwitchAccount(),
        showOverview: false,
        showAdmin: false,
        showSidebar: true,
        title: title,
        isAdmin: false,
        hasSelectedHotel: title || null,
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      this.handleRouteChange();
    }

    if (
      this.props.accountReducer.resultsAccountsListFiltered !==
      prevProps.accountReducer.resultsAccountsListFiltered &&
      this.props.accountReducer.resultsAccountsListFiltered != null &&
      this.state.sentListAccounts
    ) {
      const formattedHotels =
        this.props.accountReducer?.resultsAccountsListFiltered?.records
          ?.filter((hotel) => hotel.enabled === true)
          .map((hotel) => ({
            accountName: hotel.name,
            accountUuid: hotel.uuid,
            accountUid: hotel.uid,
            accountCurrency: hotel.currency || "",
            accountDateFormat: hotel.dateFormat || "",
            accountTimeFormat: hotel.timeFormat || "",
            accountPropertyId: hotel.propertyId || "",
            accountSubscriptionName: (hotel.subscription && hotel.subscription.name) || "",
            managePropertiesList: hotel.managePropertiesList === true ? true : false
          }));
      
      localStorage.setItem("allHotels", JSON.stringify(formattedHotels));
      window.dispatchEvent(new CustomEvent("allHotelsUpdated"));
      this.setState(
        { listHotels: formattedHotels, sentListAccounts: false },
        () => {
          this.handleWebService(this.state.listHotels, true);
          
          const pathname = this.props.location?.pathname || '';
          if (pathname.startsWith('/dashboard/') && !pathname.startsWith('/dashboard/admin')) {
            this.handleRouteChange();
          }
        }
      );
    }
    if (this.props.usersReducer.resultsUserPatch !==
      prevProps.usersReducer.resultsUserPatch &&
      this.props.usersReducer.resultsUserPatch != null &&
      this.state.sentUserUpdate) {

      const updatedUserData = {
        ...this.state.additionalUserData,
        profilePictureUri: this.props.usersReducer?.resultsUserPatch?.profilePictureUri || null
      };

      window.localStorage.setItem(
        "additionalUserData",
        JSON.stringify(updatedUserData)
      );

      this.setState({
        additionalUserData: updatedUserData,
        showProfileModal: false,
        sentUserUpdate: false
      });
    }
  }

  logout() {
    this.user = null;
    window.localStorage.clear();
    this.setState({ userData: {}, additionalUserData: {} });
  }

  handleWebService = (accountsList, isSuperUser = false) => {
    try {
      const { userDataApi } = this.state;
      const isAdmin = window.localStorage.getItem("isAdmin") === "true";
      const isOverview = window.localStorage.getItem("isOverview") === "true";
      const hasSelectedHotel = this.state.hasSelectedHotel || window.localStorage.getItem("selectedHotel");

      if (!userDataApi.accessToken) {
        this.logout();
        return;
      }

      let showHotels = false;
      let listHotels = null;
      let showSwitchAccount = false;
      let showAdmin = isSuperUser;
      let showOverview = this.shouldShowOverview();
      let dataTitle = isOverview ? "Overview" : "Admin Panel";

      if (!hasSelectedHotel) {

        const userData = safeParseJson(localStorage.getItem("userData"), {});
        const isUserAdmin = userData.roles?.includes('ROLE_ADMIN') ||
          userData.roles?.includes('ROLE_SUPERUSER');
        const realmAccess = ensureArray(safeParseJson(window.localStorage.getItem("userData"), {})?.realmAccess);
        const hasAccounts = realmAccess.length > 0;

        const showNoAccountsView = !isUserAdmin && !hasAccounts;

        if (isAdmin) {
          dataTitle = "ADMIN";
        } else if (isOverview) {
          dataTitle = "Overview";
        } else if (showNoAccountsView) {
          window.localStorage.setItem("uuidSetCookie", userDataApi.uuid);
          window.localStorage.setItem("accountUid", userDataApi.accountUid);
          window.localStorage.setItem("currencyAccount", "");
          window.localStorage.setItem("dateFormatAccount", "");
          window.localStorage.setItem("timeFormatAccount", "");
          window.localStorage.setItem("propertyIdAccount", "");
          window.localStorage.setItem("accountSubscriptionName", "");
          window.localStorage.setItem("managePropertiesList", "")
          this.setState({ showNoAccountsView: true, showSidebar: true, });
        } else if (accountsList.length === 1) {
          const account = accountsList[0];
          window.localStorage.setItem("uuidSetCookie", account.accountUuid);
          window.localStorage.setItem("accountUid", account.accountUid);
          window.localStorage.setItem("selectedHotel", account.accountName);
          window.localStorage.setItem("currencyAccount", account.accountCurrency || "");
          window.localStorage.setItem("dateFormatAccount", account.accountDateFormat || "");
          window.localStorage.setItem("timeFormatAccount", account.accountTimeFormat || "");
          window.localStorage.setItem("propertyIdAccount", account.accountPropertyId || "");
          window.localStorage.setItem("accountSubscriptionName", account.accountSubscriptionName || "");
          window.localStorage.setItem(
            "managePropertiesList",
            account.managePropertiesList === true ? "true" : "false"
          );
          dataTitle = account.accountName;
          this.props.navigate(`/dashboard/${account.accountUid}`, { replace: true });
          return;
        } else {
          window.localStorage.setItem("uuidSetCookie",
            accountsList[0]?.accountUuid || userDataApi.uuid
          );
          window.localStorage.setItem("currencyAccount", "");
          window.localStorage.setItem("dateFormatAccount", "");
          window.localStorage.setItem("timeFormatAccount", "");
          window.localStorage.setItem("propertyIdAccount", "");
          window.localStorage.setItem("accountSubscriptionName", "");
          window.localStorage.setItem("managePropertiesList", "")
          showHotels = true;
          listHotels = accountsList;
        }
      }

      if ((hasSelectedHotel && accountsList.length > 1) || isAdmin || isOverview) {
        dataTitle = isAdmin ? (hasSelectedHotel || "ADMIN") : (isOverview ? "Overview" : hasSelectedHotel);
        showSwitchAccount = accountsList.length > 1;
        showAdmin = false;
        showOverview = false;
      }
      if (hasSelectedHotel && accountsList.length === 1) {
        dataTitle = hasSelectedHotel
      }

      this.setState({
        userData: userDataApi,
        showSidebar: true,
        showHotelSelection: showHotels,
        title: dataTitle,
        mode: "ADMIN",
        listHotels,
        showSwitchAccount,
        showAdmin,
        showOverview,
      });
    } catch {
      this.logout();
    }
  };

  handleSwitchAccount = () => {
    window.localStorage.removeItem("selectedHotel");
    window.localStorage.removeItem("uuidSetCookie");
    window.localStorage.removeItem("currencyAccount");
    window.localStorage.removeItem("dateFormatAccount");
    window.localStorage.removeItem("timeFormatAccount");
    window.localStorage.removeItem("propertyIdAccount");
    window.localStorage.removeItem("accountSubscriptionName");
    window.localStorage.removeItem("managePropertiesList");
    window.localStorage.removeItem("isAdmin");
    window.localStorage.removeItem("isOverview");
    window.localStorage.removeItem("accountUid");

    this.props.resetSagaAnalyticsHighlights();

    const additionalUserData = getAdditionalUserData();
    const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");

    let listHotels = [];

    if (isSuperUser) {
      listHotels = ensureArray(safeParseJson(localStorage.getItem("allHotels"), []));
    } else {
      listHotels = (additionalUserData?.permissionsByAccount || []).map((acc) => ({
        accountName: acc.accountName,
        accountUuid: acc.accountUuid,
        accountUid: acc.accountUid,
        accountCurrency: acc.accountCurrency || "",
        accountDateFormat: acc.accountDateFormat || "",
        accountTimeFormat: acc.accountTimeFormat || "",
        accountPropertyId: acc.accountPropertyId || "",
        accountSubscriptionName: acc.accountSubscriptionName || "",
        managePropertiesList: acc.managePropertiesList === true,
        hasSelectedHotel: null,
      }));
    }

    this.setState({
      showHotelSelection: true,
      showSwitchAccount: false,
      title: "Admin Panel",
      showAdmin: isSuperUser,
      showOverview: this.shouldShowOverview(),
      listHotels,
    }, () => {
      this.props.navigate('/dashboard/select');
    });
  };

  handleSwitchAdmin = () => {
    const additionalUserData = getAdditionalUserData();
    const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
    if (!isSuperUser) {
      return;
    }

    const userDataString = window.localStorage.getItem("userData");
    const userData = userDataString ? safeParseJson(userDataString, null) : null;
    if (!userData || !userData.id) {
      this.logout();
      return;
    }
    setTimeout(() => {
      window.localStorage.removeItem("selectedHotel");
      window.localStorage.removeItem("accountUid");
      window.localStorage.setItem("isAdmin", "true");
      window.localStorage.setItem("isOverview", "false");
      window.localStorage.setItem("uuidSetCookie", this.state.userDataApi.uuid);
      window.localStorage.setItem("currencyAccount", "");
      window.localStorage.setItem("dateFormatAccount", "");
      window.localStorage.setItem("timeFormatAccount", "");
      window.localStorage.setItem("propertyIdAccount", "");
      window.localStorage.setItem("managePropertiesList", "")
      window.localStorage.setItem("accountSubscriptionName", "");
      this.props.navigate('/dashboard/admin');
    }, 0);
  };

  handleSwitchOverview = () => {
    const additionalUserData = getAdditionalUserData();
    const isSuperUser = additionalUserData?.roles?.includes("ROLE_SUPERUSER");
    if (isSuperUser) {
      return;
    }

    const userDataString = window.localStorage.getItem("userData");
    const userData = userDataString ? safeParseJson(userDataString, null) : null;
    if (!userData || !userData.id) {
      this.logout();
      return;
    }
    setTimeout(() => {
      window.localStorage.removeItem("selectedHotel");
      window.localStorage.removeItem("accountUid");
      window.localStorage.setItem("isAdmin", "false");
      window.localStorage.setItem("isOverview", "true");
      window.localStorage.setItem("uuidSetCookie", this.state.userDataApi.uuid);
      window.localStorage.setItem("currencyAccount", "");
      window.localStorage.setItem("managePropertiesList", "")
      window.localStorage.setItem("accountSubscriptionName", "");
      this.props.navigate('/dashboard/overview');
    }, 0);
  };

  handleHotelSelect = (hotel) => {
    const userDataString = window.localStorage.getItem("userData");
    const userData = userDataString ? safeParseJson(userDataString, null) : null;
    if (!userData || !userData.id) {
      this.logout();
      return;
    }

    window.localStorage.setItem("selectedHotel", hotel.accountName);
    window.localStorage.setItem("uuidSetCookie", hotel.accountUuid);
    window.localStorage.setItem("accountUid", hotel.accountUid);
    window.localStorage.setItem("currencyAccount", hotel.accountCurrency);
    window.localStorage.setItem("dateFormatAccount", hotel.accountDateFormat);
    window.localStorage.setItem("timeFormatAccount", hotel.accountTimeFormat);
    window.localStorage.setItem("propertyIdAccount", hotel.accountPropertyId);
    window.localStorage.setItem(
      "managePropertiesList",
      hotel.managePropertiesList === true ? "true" : "false"
    );
    window.localStorage.setItem("accountSubscriptionName", hotel.accountSubscriptionName);
    window.localStorage.setItem("isAdmin", false);
    window.localStorage.setItem("isOverview", "false");
    this.props.navigate(`/dashboard/${hotel.accountUid}`);
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  getFilteredHotels = (listHotels, searchText) => {
    if (
      this.filteredHotelsCache.list === listHotels &&
      this.filteredHotelsCache.searchText === searchText
    ) {
      return this.filteredHotelsCache.result;
    }

    const normalizedSearch = String(searchText || "").toLowerCase();
    const result = (listHotels || []).filter((hotel) =>
      String(hotel.accountName || "").toLowerCase().includes(normalizedSearch)
    );

    this.filteredHotelsCache = {
      list: listHotels,
      searchText,
      result,
    };

    return result;
  };

  callbackCard = (indiceCard) => {
    this.state.cards.map((value, i) => {
      if (i === indiceCard) {
        value.expanded = true;
        value.visibility = true;
      } else {
        value.expanded = false;
        value.visibility = false;
      }
      return value;
    });

    this.setState({ cards: this.state.cards });
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };
  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  callbackForgot = (res) => {
    this.setState({ responseForgot: res });
  };

  collapseAlert = () => {
    this.setState({ openAlert: false });
  };

  handleAvatarClick = (e) => {
    e.stopPropagation();
    this.setState({ showProfileModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showProfileModal: false });
  };

  handleSaveProfileImage = (file) => {
    const headersSetCookie = window.localStorage.getItem("headersSetCookie");
    let form = {}
    form['profilePictureUri'] = file
    this.props.updateUser(headersSetCookie, form, this.state.userDataApi.uuid);
    this.setState({ sentUserUpdate: true });
  };

  render() {
    const headersSetCookie = window.localStorage.getItem("headersSetCookie");

    if (!headersSetCookie) {
      return <Navigate to="/login" state={{ from: this.props.location }} replace />;
    }


    if (this.user === null) {
      return (
        <Navigate
          to="/login"
          state={{ sessionExpired: true, from: this.props.location }}
        />
      );
    }

    if (this.state.showSidebar === null) {
      return (
        <Fragment>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(245, 245, 245, 0.6)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
              zIndex: 1300,
            }}
          />
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: "20px",
              zIndex: 1400,
              pointerEvents: "none",
            }}
          >
            <CircularProgress
              size={60}
              thickness={4}
              style={{ color: "#135265" }}
            />
            <Typography variant="h6" style={{ color: "#424242" }}>
              Loading Travel Curious...
            </Typography>
          </div>
          <Theme isAdminMode={false}>
            <div
              className="wrapper MainLayout_wrapper environmentProduction navBarTopContainer"
              styles={style}
            >
              <AppBar position="absolute" className="appBar" sx={{ zIndex: 1 }}>
                <Toolbar className="toolbar_Appbar environmentProduction">
                  <Link href="/dashboard/select">
                    <img
                      className="toolbarLogo"
                      src={Logo}
                      alt="Travel Curious"
                    />
                  </Link>
                </Toolbar>
              </AppBar>
            </div>
          </Theme>
        </Fragment>
      );
    }
    const isOverviewMode =
      window.localStorage.getItem("isOverview") === "true" ||
      this.state.title === "Overview";
    const isAdminMode =
      this.state.isAdmin === "true" ||
      this.state.title === "ADMIN";
    return (
      <Fragment>
        <Theme isAdminMode={isAdminMode} isOverviewMode={isOverviewMode}>
          <div
            styles={style}
            className={
              this.environmentIdentifier === "andy"
                ? `wrapper MainLayout_wrapper environmentAndy navBarTopContainer`
                : `wrapper MainLayout_wrapper environmentProduction navBarTopContainer`
            }
          >
            {/* START HEADER */}
            <AppBar
              position="absolute"
              className={clsx("appBar", this.state.open && "appBarShift")}
            >
              <Toolbar
                className={
                  this.environmentIdentifier === "andy"
                    ? `toolbar_Appbar environmentAndy`
                    : `toolbar_Appbar environmentProduction`
                }
              >
                <Link component={RouterLink} to={buildDashboardPath("")}>
                  <img
                    className={clsx(
                      "toolbarLogo",
                      this.state.open && "toolbarLogoShow"
                    )}
                    src={Logo}
                    alt="Travel Curious"
                  />
                </Link>
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  className="title_Dashboard"
                >
                  {this.state.title}
                </Typography>

                <div className="welcomeText">
                  Welcome back, {this.state.userData.name}
                </div>

                {Object.keys(this.state.userData).length > 0 ? (
                  <>
                    {this.state.showAdmin && (
                      <Button
                        className="transparentButton"
                        onClick={this.handleSwitchAdmin}
                      >
                        ADMIN
                      </Button>
                    )}

                    {this.state.showOverview && (
                      <Button
                        className="transparentButton"
                        onClick={this.handleSwitchOverview}
                      >
                        Overview
                      </Button>
                    )}

                    {this.state.showSwitchAccount && (
                      <Button
                        className="transparentButton"
                        onClick={this.handleSwitchAccount}
                      >
                        Switch Account
                      </Button>
                    )}

                    <Avatar
                      className="MenuHeader_Avatar"
                      onClick={this.handleAvatarClick}
                      style={{
                        cursor: 'pointer',
                        borderRadius: '50%',
                        width: '40px',
                        height: '40px',
                        objectFit: 'cover',
                      }}
                      src={this.state.additionalUserData?.profilePictureUri || undefined}
                    >
                      {!this.state.additionalUserData?.profilePictureUri && (
                        <Icon className="material-symbols-outlined">person</Icon>
                      )}
                    </Avatar>

                    <MenuDropdown
                      user={this.state.userData.email}
                      buttonEndIcon={
                        <Icon className="material-symbols-outlined">
                          expand_more
                        </Icon>
                      }
                      buttonText={
                        <Typography component="span" color="inherit" noWrap>
                          {this.state.userData.firstName}
                        </Typography>
                      }
                      callbackForgot={this.callbackForgot}
                    />

                    <ProfileImageUploadModal
                      isOpen={this.state.showProfileModal}
                      onClose={this.handleCloseModal}
                      currentImage={this.state.additionalUserData?.profilePictureUri}
                      userName={this.state.userData?.name || ""}
                      onSave={this.handleSaveProfileImage}
                    />
                  </>
                ) : (
                  ""
                )}

              </Toolbar>
            </AppBar>
            {/* END HEADER */}

            {this.state.showHotelSelection ? (
              <main
                className="main_admin viewListGeneralContainer"
                style={{
                  padding: 30,
                  overflowY: "auto",
                  height: "calc(100vh)",
                }}
              >
                <div className="app_bar_spacer" />
                <Grid container className="main_admin_hotels">
                  <Grid
                    item
                    xs={12}
                    md={8}
                    style={{ margin: "0 auto" }}
                    alignItems="center"
                  >
                    <Typography variant="h6">Accounts</Typography>
                    <Typography variant="subtitle1">
                      Select the account you want to manage.
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={8} style={{ margin: "0 auto" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      placeholder="Search..."
                      value={this.state.searchText}
                      onChange={this.handleSearchChange}
                      style={{ marginBottom: "16px" }}
                    />
                    <Grid container spacing={2}>
                      {this.getFilteredHotels(this.state.listHotels || [], this.state.searchText)
                        .map((hotel) => (
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={hotel.accountUuid}
                          >
                            <Button
                              variant="contained"
                              fullWidth
                              color="primary"
                              onClick={() => this.handleHotelSelect(hotel)}
                              style={{
                                textTransform: "none",
                                padding: "16px",
                                backgroundColor: "#6C6C6C",
                              }}
                            >
                              <b>{hotel.accountName} </b>
                            </Button>
                          </Grid>
                        ))}
                    </Grid>
                  </Grid>
                </Grid>
              </main>
            ) : (
              <>
                {/* START SIDEBAR */}
                {this.state.showSidebar && <SidebarNavigation />}
                {/* END SIDEBAR */}
                <main className="main_admin">
                  <div className="app_bar_spacer" />

                  {this.state.responseForgot !== "" && (
                    <Collapse in={this.state.openAlert}>
                      <Container maxWidth={false} className="container pb-0">
                        <Alert
                          severity="info"
                          variant="filled"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                this.collapseAlert(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {this.state.responseForgot}
                        </Alert>
                      </Container>
                    </Collapse>
                  )}

                  <Container
                    fixed={true}
                    disableGutters
                    // maxWidth={false}
                    sx={{
                      width: "100% !important",
                      maxWidth: "100% !important",
                    }}
                    className="container mainLayout_container mainAdminContainer"
                  >
                    <Outlet />
                  </Container>
                </main>
              </>
            )}
          </div>
        </Theme>
      </Fragment >
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers;
};

const mapDispachToProps = (dispatch) => {
  return {
    getAccountListFiltered: (access, query, page, idUser) =>
      dispatch({ type: "GET_LIST_ACCOUNT_FILTERED", access, query, page, idUser }),
    updateUser: (access, form, id) =>
      dispatch({ type: "UPDATE_USER", access, form, id }),
    resetSagaAnalyticsHighlights: () => dispatch({ type: "RESET_ANALYTICS_HIGHLIGHTS" }),
  };
};

function withNavigate(Component) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} navigate={navigate} location={location} />;
  };
}

export default withNavigate(connect(mapStateToProps, mapDispachToProps)(MainAdmin));
